import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import AccountTypeBasicInfoComponent from './account-type-basic-info.component';
import ManagementMappedAccounts from './mapped-accounts/containers/mapped-accounts';


export const AccountTypeComponent = ({ networks, selectedAccountType, handleInnerFormChange, back, handleFormSubmit }: any) => {
  const tabItems = [
    {
      id: 1,
      title: 'AccountType Information',
      component: <AccountTypeBasicInfoComponent
        networks={networks}
        selectedAccountType={selectedAccountType}
        handleInnerFormChange={handleInnerFormChange} />,
      isVisible: true,
    },
    {
      id: 2,
      title: 'Mapped Accounts',
      component: <ManagementMappedAccounts
        selectedAccountType={selectedAccountType}

      />,
      isVisible: true,
    },
  ]
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}

          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  )
}
export default AccountTypeComponent;